module.exports = __webpack_public_path__ + "iPhone7-RoseGold-landscape.png?c0e37710818e8b3735e4d822cc0dc7f1";